// extracted by mini-css-extract-plugin
module.exports = {"flip":"Popup_flip__fwxb8","backgroundImage":"Popup_backgroundImage__qBjZR","background":"Popup_background__h2HnI","container":"Popup_container__xGvhQ"};